module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00075-fs8.2ee72cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00075-fs8.png
// module id = 228
// module chunks = 0